/*! @pentacode/ui v0.1.0 */
import { LitElement as e, css as t, html as n, isServer as r } from "lit";
import { customElement as i, property as a, query as o } from "lit/decorators.js";
import { classMap as s } from "lit/directives/class-map.js";
//#region ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.ZWQCGLB5.js
var c = class extends Event {
	constructor() {
		super("wa-reposition", {
			bubbles: !0,
			cancelable: !1,
			composed: !0
		});
	}
}, l = t`
  :host {
    --arrow-color: black;
    --arrow-size: var(--wa-tooltip-arrow-size);
    --popup-border-width: 0px;
    --show-duration: var(--wa-transition-fast);
    --hide-duration: var(--wa-transition-fast);

    /*
     * These properties are computed to account for the arrow's dimensions after being rotated 45º. The constant
     * 0.7071 is derived from sin(45) to calculate the length of the arrow after rotation.
     *
     * The diamond will be translated inward by --arrow-base-offset, the border thickness, to centralise it on
     * the inner edge of the popup border. This also means we need to increase the size of the arrow by the
     * same amount to compensate.
     *
     * A diamond shaped clipping mask is used to avoid overlap of popup content. This extends slightly inward so
     * the popup border is covered with no sub-pixel rounding artifacts. The diamond corners are mitred at 22.5º
     * to properly merge any arrow border with the popup border. The constant 1.4142 is derived from 1 + tan(22.5).
     *
     */
    --arrow-base-offset: var(--popup-border-width);
    --arrow-size-diagonal: calc((var(--arrow-size) + var(--arrow-base-offset)) * 0.7071);
    --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));
    --arrow-size-div: calc(var(--arrow-size-diagonal) * 2);
    --arrow-clipping-corner: calc(var(--arrow-base-offset) * 1.4142);

    display: contents;
  }

  .popup {
    position: absolute;
    isolation: isolate;
    max-width: var(--auto-size-available-width, none);
    max-height: var(--auto-size-available-height, none);

    /* Clear UA styles for [popover] */
    :where(&) {
      inset: unset;
      padding: unset;
      margin: unset;
      width: unset;
      height: unset;
      color: unset;
      background: unset;
      border: unset;
      overflow: unset;
    }
  }

  .popup-fixed {
    position: fixed;
  }

  .popup:not(.popup-active) {
    display: none;
  }

  .arrow {
    position: absolute;
    width: var(--arrow-size-div);
    height: var(--arrow-size-div);
    background: var(--arrow-color);
    z-index: 3;
    clip-path: polygon(
      var(--arrow-clipping-corner) 100%,
      var(--arrow-base-offset) calc(100% - var(--arrow-base-offset)),
      calc(var(--arrow-base-offset) - 2px) calc(100% - var(--arrow-base-offset)),
      calc(100% - var(--arrow-base-offset)) calc(var(--arrow-base-offset) - 2px),
      calc(100% - var(--arrow-base-offset)) var(--arrow-base-offset),
      100% var(--arrow-clipping-corner),
      100% 100%
    );
    rotate: 45deg;
  }

  :host([data-current-placement|='left']) .arrow {
    rotate: -45deg;
  }

  :host([data-current-placement|='right']) .arrow {
    rotate: 135deg;
  }

  :host([data-current-placement|='bottom']) .arrow {
    rotate: 225deg;
  }

  /* Hover bridge */
  .popup-hover-bridge:not(.popup-hover-bridge-visible) {
    display: none;
  }

  .popup-hover-bridge {
    position: fixed;
    z-index: 899;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--hover-bridge-top-left-x, 0) var(--hover-bridge-top-left-y, 0),
      var(--hover-bridge-top-right-x, 0) var(--hover-bridge-top-right-y, 0),
      var(--hover-bridge-bottom-right-x, 0) var(--hover-bridge-bottom-right-y, 0),
      var(--hover-bridge-bottom-left-x, 0) var(--hover-bridge-bottom-left-y, 0)
    );
  }

  /* Built-in animations */
  .show {
    animation: show var(--show-duration) ease;
  }

  .hide {
    animation: show var(--hide-duration) ease reverse;
  }

  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .show-with-scale {
    animation: show-with-scale var(--show-duration) ease;
  }

  .hide-with-scale {
    animation: show-with-scale var(--hide-duration) ease reverse;
  }

  @keyframes show-with-scale {
    from {
      opacity: 0;
      scale: 0.8;
    }
    to {
      opacity: 1;
      scale: 1;
    }
  }
`, u = Object.defineProperty, d = Object.getOwnPropertyDescriptor, f = (e) => {
	throw TypeError(e);
}, p = (e, t, n, r) => {
	for (var i = r > 1 ? void 0 : r ? d(t, n) : t, a = e.length - 1, o; a >= 0; a--) (o = e[a]) && (i = (r ? o(t, n, i) : o(i)) || i);
	return r && i && u(t, n, i), i;
}, m = (e, t, n) => t.has(e) || f("Cannot " + n), h = (e, t, n) => (m(e, t, "read from private field"), n ? n.call(e) : t.get(e)), g = (e, t, n) => t.has(e) ? f("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), _ = (e, t, n, r) => (m(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), v = t`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden],
  :host([hidden]) {
    display: none !important;
  }
`, y = /;\s+$/;
function b(e) {
	return e.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
}
function x(e) {
	let { property: t, value: n, element: r } = e;
	if (n) {
		let e = r.getAttribute("style") || "";
		e && (e.match(y) || (e += ";"), e += " ");
		let i = `${t}: ${n}`;
		return e.includes(i) ? void 0 : `${e}${i};`;
	}
	return null;
}
var S, C = class extends e {
	constructor() {
		super(), g(this, S, !1), this.initialReflectedProperties = /* @__PURE__ */ new Map(), this.didSSR = r || !!this.shadowRoot, this.customStates = {
			set: (e, t) => {
				if (this.internals?.states) try {
					t ? this.internals.states.add(e) : this.internals.states.delete(e);
				} catch (e) {
					if (String(e).includes("must start with '--'")) console.error("Your browser implements an outdated version of CustomStateSet. Consider using a polyfill");
					else throw e;
				}
			},
			has: (e) => {
				if (!this.internals?.states) return !1;
				try {
					return this.internals.states.has(e);
				} catch {
					return !1;
				}
			}
		};
		try {
			this.internals = this.attachInternals();
		} catch {
			console.error("Element internals are not supported in your browser. Consider using a polyfill");
		}
		this.customStates.set("wa-defined", !0);
		let e = this.constructor;
		for (let [t, n] of e.elementProperties) n.default === "inherit" && n.initial !== void 0 && typeof t == "string" && this.customStates.set(`initial-${t}-${n.initial}`, !0);
	}
	static get styles() {
		return [v, ...Array.isArray(this.css) ? this.css : this.css ? [this.css] : []];
	}
	connectedCallback() {
		super.connectedCallback(), this.didSSR || this.shadowRoot?.prepend(document.createComment(` Web Awesome: https://webawesome.com/docs/components/${this.localName.replace("wa-", "")} `)), this.didSSR && this.updateComplete.then(() => {
			this.shadowRoot?.prepend(document.createComment(` Web Awesome: https://webawesome.com/docs/components/${this.localName.replace("wa-", "")} `));
		});
	}
	attributeChangedCallback(e, t, n) {
		h(this, S) || (this.constructor.elementProperties.forEach((e, t) => {
			e.reflect && this[t] != null && this.initialReflectedProperties.set(t, this[t]);
		}), _(this, S, !0)), super.attributeChangedCallback(e, t, n);
	}
	willUpdate(e) {
		super.willUpdate(e), this.initialReflectedProperties.forEach((t, n) => {
			e.has(n) && this[n] == null && (this[n] = t);
		});
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.didSSR && this.shadowRoot?.querySelectorAll("slot").forEach((e) => {
			e.dispatchEvent(new Event("slotchange", {
				bubbles: !0,
				composed: !1,
				cancelable: !1
			}));
		});
	}
	update(e) {
		try {
			super.update(e);
		} catch (e) {
			if (this.didSSR && !this.hasUpdated) {
				let t = new Event("lit-hydration-error", {
					bubbles: !0,
					composed: !0,
					cancelable: !1
				});
				t.error = e, this.dispatchEvent(t);
			}
			throw e;
		}
	}
	setStyle(e, t) {
		if (!this.style) {
			let n = x({
				property: b(e),
				value: t,
				element: this
			});
			n && this.setAttribute("style", n);
			return;
		}
		this.style[e] = t;
	}
	setStyleProperty(e, t) {
		if (!this.style) {
			let n = x({
				property: e,
				value: t,
				element: this
			});
			n && this.setAttribute("style", n);
			return;
		}
		this.style.setProperty(e, t);
	}
	relayNativeEvent(e, t) {
		e.stopImmediatePropagation(), this.dispatchEvent(new e.constructor(e.type, {
			...e,
			...t
		}));
	}
};
S = /* @__PURE__ */ new WeakMap(), p([a()], C.prototype, "dir", 2), p([a()], C.prototype, "lang", 2), p([a({
	type: Boolean,
	reflect: !0,
	attribute: "did-ssr"
})], C.prototype, "didSSR", 2);
//#endregion
//#region ../../node_modules/.pnpm/@shoelace-style+localize@3.2.3/node_modules/@shoelace-style/localize/dist/index.js
var w = /* @__PURE__ */ new Set(), T = /* @__PURE__ */ new Map(), E, D = "ltr", O = "en", ee = typeof MutationObserver < "u" && typeof document < "u" && document.documentElement !== void 0;
if (ee) {
	let e = new MutationObserver(A);
	D = document.documentElement.dir || "ltr", O = document.documentElement.lang || navigator.language, e.observe(document.documentElement, {
		attributes: !0,
		attributeFilter: ["dir", "lang"]
	});
}
function k(...e) {
	e.map((e) => {
		let t = e.$code.toLowerCase();
		T.has(t) ? T.set(t, Object.assign(Object.assign({}, T.get(t)), e)) : T.set(t, e), E ||= e;
	}), A();
}
function A() {
	ee && (D = document.documentElement.dir || "ltr", O = document.documentElement.lang || navigator.language), [...w.keys()].map((e) => {
		typeof e.requestUpdate == "function" && e.requestUpdate();
	});
}
var te = class {
	constructor(e) {
		this.host = e, this.host.addController(this);
	}
	hostConnected() {
		w.add(this.host);
	}
	hostDisconnected() {
		w.delete(this.host);
	}
	dir() {
		return `${this.host.dir || D}`.toLowerCase();
	}
	lang() {
		let e = `${this.host.lang || O}`.toLowerCase().replace(/_/g, "-");
		try {
			return new Intl.Locale(e), e;
		} catch {
			return E ? E.$code.toLowerCase() : "en";
		}
	}
	getTranslationData(e) {
		let t;
		try {
			t = new Intl.Locale(e.replace(/_/g, "-"));
		} catch {
			return {
				locale: void 0,
				language: "",
				region: "",
				primary: void 0,
				secondary: void 0
			};
		}
		let n = t.language.toLowerCase(), r = t.region?.toLowerCase() ?? "", i = T.get(`${n}-${r}`), a = T.get(n);
		return {
			locale: t,
			language: n,
			region: r,
			primary: i,
			secondary: a
		};
	}
	exists(e, t) {
		let { primary: n, secondary: r } = this.getTranslationData(t.lang ?? this.lang());
		return t = Object.assign({ includeFallback: !1 }, t), !!(n && n[e] || r && r[e] || t.includeFallback && E && E[e]);
	}
	term(e, ...t) {
		let { primary: n, secondary: r } = this.getTranslationData(this.lang()), i;
		if (n && n[e]) i = n[e];
		else if (r && r[e]) i = r[e];
		else if (E && E[e]) i = E[e];
		else return console.error(`No translation found for: ${String(e)}`), String(e);
		return typeof i == "function" ? i(...t) : i;
	}
	date(e, t) {
		return e = new Date(e), new Intl.DateTimeFormat(this.lang(), t).format(e);
	}
	number(e, t) {
		return e = Number(e), isNaN(e) ? "" : new Intl.NumberFormat(this.lang(), t).format(e);
	}
	relativeTime(e, t, n) {
		return new Intl.RelativeTimeFormat(this.lang(), n).format(e, t);
	}
}, j = {
	$code: "en",
	$name: "English",
	$dir: "ltr",
	allTagsRemoved: "All tags removed",
	am: "AM",
	autosizeColumn: "Autosize column",
	captions: "Captions",
	carousel: "Carousel",
	chooseDate: "Choose date",
	chooseDecade: "Choose decade",
	chooseMonth: "Choose month",
	chooseTime: "Choose time",
	chooseYear: "Choose year",
	clearEntry: "Clear entry",
	clearFilter: "Clear filter",
	clearSort: "Clear sort",
	close: "Close",
	closeCalendar: "Close calendar",
	closeTimeInput: "Close time picker",
	collapseRow: "Collapse row",
	columnMenu: "Column options",
	columnMovedToPosition: (e, t, n) => `${e} moved to position ${t} of ${n}`,
	columns: "Columns",
	compactPageXOfY: (e, t) => `${e} of ${t}`,
	completed: "Completed",
	copied: "Copied",
	copy: "Copy",
	createOption: (e) => `Create "${e}"`,
	currentlyPlaying: "currently playing",
	currentValue: "Current value",
	date: "Date",
	datePickerKeyboardHelp: "Use arrow keys to change values; press Alt+Down Arrow to open the calendar.",
	day: "Day",
	dayPeriod: "AM/PM",
	decrement: "Decrement",
	deselectAllRows: "Deselect all rows",
	disabled: "Disabled",
	dropFileHere: "Drop file here or click to browse",
	dropFilesHere: "Drop files here or click to browse",
	empty: "Empty",
	endDate: "End date",
	enterFullscreen: "Enter fullscreen",
	error: "Error",
	exitFullscreen: "Exit fullscreen",
	expandRow: "Expand row",
	filterByColumn: (e) => `Filter by ${e}`,
	filterFrom: "From",
	filterMax: "Max",
	filterMin: "Min",
	filterTo: "To",
	firstPage: "First page",
	goToSlide: (e, t) => `Go to slide ${e} of ${t}`,
	hideColumn: "Hide column",
	hidePassword: "Hide password",
	hour: "Hour",
	incompleteDate: "Enter a valid date.",
	increment: "Increment",
	jumpBackwardX: (e) => `Jump back ${e} pages`,
	jumpForwardX: (e) => `Jump forward ${e} pages`,
	lastPage: "Last page",
	loading: "Loading",
	locked: "Locked",
	minute: "Minute",
	month: "Month",
	moreOptions: "More Options",
	mute: "Mute",
	nextDecade: "Next decade",
	nextMonth: "Next month",
	nextPage: "Next page",
	nextSlide: "Next slide",
	nextVideo: "Next Video",
	nextYear: "Next year",
	noData: "No data",
	noOptions: "No options",
	noResults: "No matching results",
	notCompleted: "Not completed",
	now: "Now",
	numCharacters: (e) => e === 1 ? "1 character" : `${e} characters`,
	numCharactersRemaining: (e) => e === 1 ? "1 character remaining" : `${e} characters remaining`,
	numOptionsAvailable: (e) => e === 0 ? "No options available" : e === 1 ? "1 option available" : `${e} options available`,
	numOptionsSelected: (e) => e === 0 ? "No options selected" : e === 1 ? "1 option selected" : `${e} options selected`,
	numRowsCopied: (e) => e === 1 ? "1 row copied" : `${e} rows copied`,
	numRowsSelected: (e) => e === 1 ? "1 row selected" : `${e} rows selected`,
	optionPosition: (e, t, n) => `${e}, ${t} of ${n}`,
	optionsLoadError: "Options could not be loaded",
	pageXOfY: (e, t) => `Page ${e} of ${t}`,
	pagination: "Pagination",
	pause: "Pause",
	pauseAnimation: "Pause animation",
	pictureInPicture: "Picture in picture",
	pinLeft: "Pin left",
	pinRight: "Pin right",
	play: "Play",
	playAnimation: "Play animation",
	playbackSpeed: "Playback speed",
	playlist: "Playlist",
	pm: "PM",
	previousDecade: "Previous decade",
	previousMonth: "Previous month",
	previousPage: "Previous page",
	previousSlide: "Previous slide",
	previousVideo: "Previous video",
	previousYear: "Previous year",
	progress: "Progress",
	rangeTooLong: (e) => e === 1 ? "Select a range no longer than 1 day" : `Select a range no longer than ${e} days`,
	rangeTooShort: (e) => e === 1 ? "Select a range at least 1 day long" : `Select a range at least ${e} days long`,
	readonly: "Read-only",
	remove: "Remove",
	resetColumns: "Reset columns",
	resize: "Resize",
	resizeColumn: "Resize column",
	rowsPerPage: "Rows per page",
	scrollableRegion: "Scrollable region",
	scrollToEnd: "Scroll to end",
	scrollToStart: "Scroll to start",
	search: "Search",
	second: "Second",
	seek: "Seek",
	seekProgress: (e, t) => `${e} of ${t}`,
	selectAColorFromTheScreen: "Select a color from the screen",
	selectAllRows: "Select all rows",
	selected: "Selected",
	selectedDateLabel: (e) => `Selected: ${e}`,
	selectedRangeLabel: (e) => `Selected range: ${e}`,
	selectGroup: "Select group",
	selectionCleared: "Selection cleared",
	selectRow: "Select row",
	showingNofMRows: (e, t) => `Showing ${e} of ${t} rows`,
	showingXtoYofZ: (e, t, n) => `${e}\u2013${t} of ${n}`,
	showPassword: "Show password",
	slideNum: (e) => `Slide ${e}`,
	sortAscending: "Sort ascending",
	sortColumn: "Sort column",
	sortDescending: "Sort descending",
	startDate: "Start date",
	steps: "Steps",
	stepXOfY: (e, t) => `Step ${e} of ${t}`,
	tagAdded: (e) => `${e} added`,
	tagAlreadyAdded: (e) => `${e} is already added`,
	tagInputKeyboardHelp: "Press Backspace or Delete to remove this tag.",
	tagRemoved: (e) => `${e} removed`,
	time: "Time",
	timeInputKeyboardHelp: "Use arrow keys to change values; press Alt+Down Arrow to open the time picker.",
	today: "Today",
	toggleColorFormat: "Toggle color format",
	tooFewTags: (e) => e === 1 ? "Add at least 1 tag" : `Add at least ${e} tags`,
	tooManyTags: (e) => e === 1 ? "Add no more than 1 tag" : `Add no more than ${e} tags`,
	unmute: "Unmute",
	unpin: "Unpin",
	unpinColumn: "Unpin column",
	videoPlayer: "Video player",
	volume: "Volume",
	year: "Year",
	zoomIn: "Zoom in",
	zoomOut: "Zoom out"
};
k(j);
var ne = j, re = class extends te {
	lang() {
		return this.host.didSSR && !this.host.hasUpdated ? this.host.lang || "en" : super.lang();
	}
};
k(ne);
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+utils@0.2.11/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var M = Math.min, N = Math.max, ie = Math.round, ae = Math.floor, P = (e) => ({
	x: e,
	y: e
}), oe = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function se(e, t, n) {
	return N(e, M(t, n));
}
function F(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function I(e) {
	return e.split("-")[0];
}
function L(e) {
	return e.split("-")[1];
}
function ce(e) {
	return e === "x" ? "y" : "x";
}
function le(e) {
	return e === "y" ? "height" : "width";
}
function R(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function ue(e) {
	return ce(R(e));
}
function de(e, t, n) {
	n === void 0 && (n = !1);
	let r = L(e), i = ue(e), a = le(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = z(o)), [o, z(o)];
}
function fe(e) {
	let t = z(e);
	return [
		pe(e),
		t,
		pe(t)
	];
}
function pe(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var me = ["left", "right"], he = ["right", "left"], ge = ["top", "bottom"], _e = ["bottom", "top"];
function ve(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? he : me : t ? me : he;
		case "left":
		case "right": return t ? ge : _e;
		default: return [];
	}
}
function ye(e, t, n, r) {
	let i = L(e), a = ve(I(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(pe)))), a;
}
function z(e) {
	let t = I(e);
	return oe[t] + e.slice(t.length);
}
function be(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function xe(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : be(e);
}
function Se(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+core@1.7.5/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function Ce(e, t, n) {
	let { reference: r, floating: i } = e, a = R(t), o = ue(t), s = le(o), c = I(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (L(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end": p[o] += f * (n && l ? -1 : 1);
	}
	return p;
}
async function we(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = F(t, e), p = xe(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = Se(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = Se(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var Te = 50, Ee = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: we
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Ce(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < Te && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = Ce(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, De = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = F(e, t) || {};
		if (l == null) return {};
		let d = xe(u), f = {
			x: n,
			y: r
		}, p = ue(i), m = le(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = M(d[_], T), D = M(d[v], T), O = E, ee = C - h[m] - D, k = C / 2 - h[m] / 2 + w, A = se(O, k, ee), te = !c.arrow && L(i) != null && k !== A && a.reference[m] / 2 - (k < O ? E : D) - h[m] / 2 < 0, j = te ? k < O ? k - O : k - ee : 0;
		return {
			[p]: f[p] + j,
			data: {
				[p]: A,
				centerOffset: k - A - j,
				...te && { alignmentOffset: j }
			},
			reset: te
		};
	}
}), Oe = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = F(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = I(r), _ = R(o), v = I(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [z(o)] : fe(o)), x = p !== "none";
			!d && x && b.push(...ye(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = de(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (u !== "alignment" || _ === R(t) || T.every((e) => R(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = R(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement": n = o;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
}, ke = /*#__PURE__*/ new Set(["left", "top"]);
async function Ae(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = I(n), s = L(n), c = R(n) === "y", l = ke.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = F(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var je = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Ae(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, Me = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = F(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = R(I(i)), p = ce(f), m = u[p], h = u[f];
			if (o) {
				let e = p === "y" ? "top" : "left", t = p === "y" ? "bottom" : "right", n = m + d[e], r = m - d[t];
				m = se(n, m, r);
			}
			if (s) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = h + d[e], r = h - d[t];
				h = se(n, h, r);
			}
			let g = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				...g,
				data: {
					x: g.x - n,
					y: g.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
}, Ne = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			var n, r;
			let { placement: i, rects: a, platform: o, elements: s } = t, { apply: c = () => {}, ...l } = F(e, t), u = await o.detectOverflow(t, l), d = I(i), f = L(i), p = R(i) === "y", { width: m, height: h } = a.floating, g, _;
			d === "top" || d === "bottom" ? (g = d, _ = f === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, g = f === "end" ? "top" : "bottom");
			let v = h - u.top - u.bottom, y = m - u.left - u.right, b = M(h - u[g], v), x = M(m - u[_], y), S = !t.middlewareData.shift, C = b, w = x;
			if ((n = t.middlewareData.shift) != null && n.enabled.x && (w = y), (r = t.middlewareData.shift) != null && r.enabled.y && (C = v), S && !f) {
				let e = N(u.left, 0), t = N(u.right, 0), n = N(u.top, 0), r = N(u.bottom, 0);
				p ? w = m - 2 * (e !== 0 || t !== 0 ? e + t : N(u.left, u.right)) : C = h - 2 * (n !== 0 || r !== 0 ? n + r : N(u.top, u.bottom));
			}
			await c({
				...t,
				availableWidth: w,
				availableHeight: C
			});
			let T = await o.getDimensions(s.floating);
			return m !== T.width || h !== T.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+utils@0.2.11/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Pe() {
	return typeof window < "u";
}
function B(e) {
	return Fe(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function V(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function H(e) {
	return ((Fe(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Fe(e) {
	return Pe() ? e instanceof Node || e instanceof V(e).Node : !1;
}
function U(e) {
	return Pe() ? e instanceof Element || e instanceof V(e).Element : !1;
}
function W(e) {
	return Pe() ? e instanceof HTMLElement || e instanceof V(e).HTMLElement : !1;
}
function Ie(e) {
	return !Pe() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof V(e).ShadowRoot;
}
function G(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = J(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function Le(e) {
	return /^(table|td|th)$/.test(B(e));
}
function Re(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var ze = /transform|translate|scale|rotate|perspective|filter/, Be = /paint|layout|strict|content/, K = (e) => !!e && e !== "none", Ve;
function He(e) {
	let t = U(e) ? J(e) : e;
	return K(t.transform) || K(t.translate) || K(t.scale) || K(t.rotate) || K(t.perspective) || !We() && (K(t.backdropFilter) || K(t.filter)) || ze.test(t.willChange || "") || Be.test(t.contain || "");
}
function Ue(e) {
	let t = Y(e);
	for (; W(t) && !q(t);) {
		if (He(t)) return t;
		if (Re(t)) return null;
		t = Y(t);
	}
	return null;
}
function We() {
	return Ve ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), Ve;
}
function q(e) {
	return /^(html|body|#document)$/.test(B(e));
}
function J(e) {
	return V(e).getComputedStyle(e);
}
function Ge(e) {
	return U(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function Y(e) {
	if (B(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Ie(e) && e.host || H(e);
	return Ie(t) ? t.host : t;
}
function Ke(e) {
	let t = Y(e);
	return q(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : W(t) && G(t) ? t : Ke(t);
}
function X(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = Ke(e), i = r === e.ownerDocument?.body, a = V(r);
	if (i) {
		let e = qe(a);
		return t.concat(a, a.visualViewport || [], G(r) ? r : [], e && n ? X(e) : []);
	}
	return t.concat(r, X(r, [], n));
}
function qe(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+dom@1.7.6/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function Je(e) {
	let t = J(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = W(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = ie(n) !== a || ie(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function Ye(e) {
	return U(e) ? e : e.contextElement;
}
function Z(e) {
	let t = Ye(e);
	if (!W(t)) return P(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = Je(t), o = (a ? ie(n.width) : n.width) / r, s = (a ? ie(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var Xe = /*#__PURE__*/ P(0);
function Ze(e) {
	let t = V(e);
	return !We() || !t.visualViewport ? Xe : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function Qe(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== V(e) ? !1 : t;
}
function Q(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = Ye(e), o = P(1);
	t && (r ? U(r) && (o = Z(r)) : o = Z(e));
	let s = Qe(a, n, r) ? Ze(a) : P(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = V(a), t = r && U(r) ? V(r) : r, n = e, i = qe(n);
		for (; i && r && t !== n;) {
			let e = Z(i), t = i.getBoundingClientRect(), r = J(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = V(i), i = qe(n);
		}
	}
	return Se({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function $e(e, t) {
	let n = Ge(e).scrollLeft;
	return t ? t.left + n : Q(H(e)).left + n;
}
function et(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - $e(e, n),
		y: n.top + t.scrollTop
	};
}
function tt(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = H(r), s = t ? Re(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = P(1), u = P(0), d = W(r);
	if ((d || !d && !a) && ((B(r) !== "body" || G(o)) && (c = Ge(r)), d)) {
		let e = Q(r);
		l = Z(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? et(o, c) : P(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function nt(e) {
	return Array.from(e.getClientRects());
}
function rt(e) {
	let t = H(e), n = Ge(e), r = e.ownerDocument.body, i = N(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = N(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + $e(e), s = -n.scrollTop;
	return J(r).direction === "rtl" && (o += N(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var it = 25;
function at(e, t) {
	let n = V(e), r = H(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = We();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = $e(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= it && (a -= o);
	} else l <= it && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
function ot(e, t) {
	let n = Q(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = W(e) ? Z(e) : P(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function st(e, t, n) {
	let r;
	if (t === "viewport") r = at(e, n);
	else if (t === "document") r = rt(H(e));
	else if (U(t)) r = ot(t, n);
	else {
		let n = Ze(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return Se(r);
}
function ct(e, t) {
	let n = Y(e);
	return n === t || !U(n) || q(n) ? !1 : J(n).position === "fixed" || ct(n, t);
}
function lt(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = X(e, [], !1).filter((e) => U(e) && B(e) !== "body"), i = null, a = J(e).position === "fixed", o = a ? Y(e) : e;
	for (; U(o) && !q(o);) {
		let t = J(o), n = He(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && (i.position === "absolute" || i.position === "fixed") || G(o) && !n && ct(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = Y(o);
	}
	return t.set(e, r), r;
}
function ut(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Re(t) ? [] : lt(t, this._c) : [].concat(n), r], o = st(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = st(t, a[e], i);
		s = N(n.top, s), c = M(n.right, c), l = M(n.bottom, l), u = N(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function dt(e) {
	let { width: t, height: n } = Je(e);
	return {
		width: t,
		height: n
	};
}
function ft(e, t, n) {
	let r = W(t), i = H(t), a = n === "fixed", o = Q(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = P(0);
	function l() {
		c.x = $e(i);
	}
	if (r || !r && !a) {
		if ((B(t) !== "body" || G(i)) && (s = Ge(t)), r) {
			let e = Q(t, !0, a, t);
			c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
		} else i && l();
	}
	a && !r && i && l();
	let u = i && !r && !a ? et(i, s) : P(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function pt(e) {
	return J(e).position === "static";
}
function mt(e, t) {
	if (!W(e) || J(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return H(e) === n && (n = n.ownerDocument.body), n;
}
function ht(e, t) {
	let n = V(e);
	if (Re(e)) return n;
	if (!W(e)) {
		let t = Y(e);
		for (; t && !q(t);) {
			if (U(t) && !pt(t)) return t;
			t = Y(t);
		}
		return n;
	}
	let r = mt(e, t);
	for (; r && Le(r) && pt(r);) r = mt(r, t);
	return r && q(r) && pt(r) && !He(r) ? n : r || Ue(e) || n;
}
var gt = async function(e) {
	let t = this.getOffsetParent || ht, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: ft(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function _t(e) {
	return J(e).direction === "rtl";
}
var vt = {
	convertOffsetParentRelativeRectToViewportRelativeRect: tt,
	getDocumentElement: H,
	getClippingRect: ut,
	getOffsetParent: ht,
	getElementRects: gt,
	getClientRects: nt,
	getDimensions: dt,
	getScale: Z,
	isElement: U,
	isRTL: _t
};
function yt(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function bt(e, t) {
	let n = null, r, i = H(e);
	function a() {
		var e;
		clearTimeout(r), (e = n) == null || e.disconnect(), n = null;
	}
	function o(s, c) {
		s === void 0 && (s = !1), c === void 0 && (c = 1), a();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (s || t(), !f || !p) return;
		let m = ae(d), h = ae(i.clientWidth - (u + f)), g = ae(i.clientHeight - (d + p)), _ = ae(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: N(0, M(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (n !== c) {
				if (!y) return o();
				n ? o(!1, n) : r = setTimeout(() => {
					o(!1, 1e-7);
				}, 1e3);
			}
			n === 1 && !yt(l, e.getBoundingClientRect()) && o(), y = !1;
		}
		try {
			n = new IntersectionObserver(b, {
				...v,
				root: i.ownerDocument
			});
		} catch {
			n = new IntersectionObserver(b, v);
		}
		n.observe(e);
	}
	return o(!0), a;
}
function xt(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = Ye(e), u = i || a ? [...l ? X(l) : [], ...t ? X(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n, { passive: !0 }), a && e.addEventListener("resize", n);
	});
	let d = l && s ? bt(l, n) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? Q(e) : null;
	c && g();
	function g() {
		let t = Q(e);
		h && !yt(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var St = je, Ct = Me, wt = Oe, Tt = Ne, Et = De, Dt = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: vt,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return Ee(e, t, {
		...i,
		platform: a
	});
};
//#endregion
//#region ../../node_modules/.pnpm/composed-offset-position@0.0.6_@floating-ui+utils@0.2.11/node_modules/composed-offset-position/dist/composed-offset-position.browser.min.mjs
function Ot(e) {
	return At(e);
}
function kt(e) {
	return e.assignedSlot ? e.assignedSlot : e.parentNode instanceof ShadowRoot ? e.parentNode.host : e.parentNode;
}
function At(e) {
	for (let t = e; t; t = kt(t)) if (t instanceof Element && getComputedStyle(t).display === "none") return null;
	for (let t = kt(e); t; t = kt(t)) {
		if (!(t instanceof Element)) continue;
		let e = getComputedStyle(t);
		if (e.display !== "contents" && (e.position !== "static" || He(e) || t.tagName === "BODY")) return t;
	}
	return null;
}
//#endregion
//#region ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.UEBQI7VV.js
function jt(e) {
	return typeof e == "object" && !!e && "getBoundingClientRect" in e && ("contextElement" in e ? e instanceof Element : !0);
}
var Mt = !!globalThis?.HTMLElement?.prototype.hasOwnProperty("popover"), $ = class extends C {
	constructor() {
		super(...arguments), this.localize = new re(this), this.SUPPORTS_POPOVER = !1, this.active = !1, this.placement = "top", this.boundary = "viewport", this.distance = 0, this.skidding = 0, this.arrow = !1, this.arrowPlacement = "anchor", this.arrowPadding = 10, this.flip = !1, this.flipFallbackPlacements = "", this.flipFallbackStrategy = "best-fit", this.flipPadding = 0, this.shift = !1, this.shiftPadding = 0, this.autoSizePadding = 0, this.hoverBridge = !1, this.updateHoverBridge = () => {
			if (this.hoverBridge && this.anchorEl && this.popup) {
				let e = this.anchorEl.getBoundingClientRect(), t = this.popup.getBoundingClientRect(), n = this.placement.includes("top") || this.placement.includes("bottom"), r = 0, i = 0, a = 0, o = 0, s = 0, c = 0, l = 0, u = 0;
				n ? e.top < t.top ? (r = e.left, i = e.bottom, a = e.right, o = e.bottom, s = t.left, c = t.top, l = t.right, u = t.top) : (r = t.left, i = t.bottom, a = t.right, o = t.bottom, s = e.left, c = e.top, l = e.right, u = e.top) : e.left < t.left ? (r = e.right, i = e.top, a = t.left, o = t.top, s = e.right, c = e.bottom, l = t.left, u = t.bottom) : (r = t.right, i = t.top, a = e.left, o = e.top, s = t.right, c = t.bottom, l = e.left, u = e.bottom), this.style.setProperty("--hover-bridge-top-left-x", `${r}px`), this.style.setProperty("--hover-bridge-top-left-y", `${i}px`), this.style.setProperty("--hover-bridge-top-right-x", `${a}px`), this.style.setProperty("--hover-bridge-top-right-y", `${o}px`), this.style.setProperty("--hover-bridge-bottom-left-x", `${s}px`), this.style.setProperty("--hover-bridge-bottom-left-y", `${c}px`), this.style.setProperty("--hover-bridge-bottom-right-x", `${l}px`), this.style.setProperty("--hover-bridge-bottom-right-y", `${u}px`);
			}
		};
	}
	async connectedCallback() {
		super.connectedCallback(), await this.updateComplete, this.SUPPORTS_POPOVER = Mt, this.start();
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.stop();
	}
	async updated(e) {
		super.updated(e), e.has("active") && (this.active ? this.start() : this.stop()), e.has("anchor") && this.handleAnchorChange(), this.active && (await this.updateComplete, this.reposition());
	}
	async handleAnchorChange() {
		if (await this.stop(), this.anchor && typeof this.anchor == "string") {
			let e = this.getRootNode();
			this.anchorEl = e.getElementById(this.anchor);
		} else this.anchorEl = this.anchor instanceof Element || jt(this.anchor) ? this.anchor : this.querySelector("[slot=\"anchor\"]");
		this.anchorEl instanceof HTMLSlotElement && (this.anchorEl = this.anchorEl.assignedElements({ flatten: !0 })[0]), this.anchorEl && this.start();
	}
	start() {
		this.anchorEl && this.active && this.isConnected && (this.popup?.showPopover?.(), this.cleanup = xt(this.anchorEl, this.popup, () => {
			this.reposition();
		}));
	}
	async stop() {
		return new Promise((e) => {
			this.popup?.hidePopover?.(), this.cleanup ? (this.cleanup(), this.cleanup = void 0, this.removeAttribute("data-current-placement"), this.style.removeProperty("--auto-size-available-width"), this.style.removeProperty("--auto-size-available-height"), requestAnimationFrame(() => e())) : e();
		});
	}
	reposition() {
		if (!this.active || !this.anchorEl || !this.popup) return;
		let e = [St({
			mainAxis: this.distance,
			crossAxis: this.skidding
		})];
		this.sync ? e.push(Tt({ apply: ({ rects: e }) => {
			let t = this.sync === "width" || this.sync === "both", n = this.sync === "height" || this.sync === "both";
			this.popup.style.width = t ? `${e.reference.width}px` : "", this.popup.style.height = n ? `${e.reference.height}px` : "";
		} })) : (this.popup.style.width = "", this.popup.style.height = "");
		let t;
		this.SUPPORTS_POPOVER && !jt(this.anchor) && this.boundary === "scroll" && (t = X(this.anchorEl).filter((e) => e instanceof Element)), this.flip && e.push(wt({
			boundary: this.flipBoundary || t,
			fallbackPlacements: this.flipFallbackPlacements,
			fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
			padding: this.flipPadding
		})), this.shift && e.push(Ct({
			boundary: this.shiftBoundary || t,
			padding: this.shiftPadding
		})), this.autoSize ? e.push(Tt({
			boundary: this.autoSizeBoundary || t,
			padding: this.autoSizePadding,
			apply: ({ availableWidth: e, availableHeight: t }) => {
				this.autoSize === "vertical" || this.autoSize === "both" ? this.style.setProperty("--auto-size-available-height", `${t}px`) : this.style.removeProperty("--auto-size-available-height"), this.autoSize === "horizontal" || this.autoSize === "both" ? this.style.setProperty("--auto-size-available-width", `${e}px`) : this.style.removeProperty("--auto-size-available-width");
			}
		})) : (this.style.removeProperty("--auto-size-available-width"), this.style.removeProperty("--auto-size-available-height")), this.arrow && e.push(Et({
			element: this.arrowEl,
			padding: this.arrowPadding
		}));
		let n = this.SUPPORTS_POPOVER ? (e) => vt.getOffsetParent(e, Ot) : vt.getOffsetParent;
		Dt(this.anchorEl, this.popup, {
			placement: this.placement,
			middleware: e,
			strategy: this.SUPPORTS_POPOVER ? "absolute" : "fixed",
			platform: {
				...vt,
				getOffsetParent: n
			}
		}).then(({ x: e, y: t, middlewareData: n, placement: r }) => {
			let i = this.localize.dir() === "rtl", a = {
				top: "bottom",
				right: "left",
				bottom: "top",
				left: "right"
			}[r.split("-")[0]];
			if (this.setAttribute("data-current-placement", r), Object.assign(this.popup.style, {
				left: `${e}px`,
				top: `${t}px`
			}), this.arrow) {
				let e = n.arrow.x, t = n.arrow.y, r = "", o = "", s = "", c = "";
				if (this.arrowPlacement === "start") {
					let n = typeof e == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
					r = typeof t == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "", o = i ? n : "", c = i ? "" : n;
				} else if (this.arrowPlacement === "end") {
					let n = typeof e == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
					o = i ? "" : n, c = i ? n : "", s = typeof t == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
				} else this.arrowPlacement === "center" ? (c = typeof e == "number" ? "calc(50% - var(--arrow-size-diagonal))" : "", r = typeof t == "number" ? "calc(50% - var(--arrow-size-diagonal))" : "") : (c = typeof e == "number" ? `${e}px` : "", r = typeof t == "number" ? `${t}px` : "");
				Object.assign(this.arrowEl.style, {
					top: r,
					right: o,
					bottom: s,
					left: c,
					[a]: "calc(var(--arrow-base-offset) - var(--arrow-size-diagonal))"
				});
			}
		}), requestAnimationFrame(() => this.updateHoverBridge()), this.dispatchEvent(new c());
	}
	render() {
		return n`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <span
        part="hover-bridge"
        class=${s({
			"popup-hover-bridge": !0,
			"popup-hover-bridge-visible": this.hoverBridge && this.active
		})}
      ></span>

      <div
        popover="manual"
        part="popup"
        class=${s({
			popup: !0,
			"popup-active": this.active,
			"popup-fixed": !this.SUPPORTS_POPOVER,
			"popup-has-arrow": this.arrow
		})}
      >
        <slot></slot>
        ${this.arrow ? n`<div part="arrow" class="arrow" role="presentation"></div>` : ""}
      </div>
    `;
	}
};
$.css = l, p([o(".popup")], $.prototype, "popup", 2), p([o(".arrow")], $.prototype, "arrowEl", 2), p([a({
	attribute: !1,
	type: Boolean
})], $.prototype, "SUPPORTS_POPOVER", 2), p([a()], $.prototype, "anchor", 2), p([a({
	type: Boolean,
	reflect: !0
})], $.prototype, "active", 2), p([a({ reflect: !0 })], $.prototype, "placement", 2), p([a()], $.prototype, "boundary", 2), p([a({ type: Number })], $.prototype, "distance", 2), p([a({ type: Number })], $.prototype, "skidding", 2), p([a({ type: Boolean })], $.prototype, "arrow", 2), p([a({ attribute: "arrow-placement" })], $.prototype, "arrowPlacement", 2), p([a({
	attribute: "arrow-padding",
	type: Number
})], $.prototype, "arrowPadding", 2), p([a({ type: Boolean })], $.prototype, "flip", 2), p([a({
	attribute: "flip-fallback-placements",
	converter: {
		fromAttribute: (e) => e.split(" ").map((e) => e.trim()).filter((e) => e !== ""),
		toAttribute: (e) => e.join(" ")
	}
})], $.prototype, "flipFallbackPlacements", 2), p([a({ attribute: "flip-fallback-strategy" })], $.prototype, "flipFallbackStrategy", 2), p([a({ type: Object })], $.prototype, "flipBoundary", 2), p([a({
	attribute: "flip-padding",
	type: Number
})], $.prototype, "flipPadding", 2), p([a({ type: Boolean })], $.prototype, "shift", 2), p([a({ type: Object })], $.prototype, "shiftBoundary", 2), p([a({
	attribute: "shift-padding",
	type: Number
})], $.prototype, "shiftPadding", 2), p([a({ attribute: "auto-size" })], $.prototype, "autoSize", 2), p([a()], $.prototype, "sync", 2), p([a({ type: Object })], $.prototype, "autoSizeBoundary", 2), p([a({
	attribute: "auto-size-padding",
	type: Number
})], $.prototype, "autoSizePadding", 2), p([a({
	attribute: "hover-bridge",
	type: Boolean
})], $.prototype, "hoverBridge", 2), $ = p([i("wa-popup")], $);
//#endregion
export { St as a, C as c, wt as i, p as l, xt as n, Ct as o, Dt as r, re as s, $ as t };

//# sourceMappingURL=chunk.UEBQI7VV-cl3cPog2.js.map